
import { Component, Vue } from "vue-property-decorator";
import RelayKeysMobile from "@/components/relays/RelayKeys/mobile.vue";

@Component({
  components: {
    RelayKeysMobile,
  },
})
export default class RelaysMobile extends Vue {

  private search: string = "";

  private enterKeyPress(e) {
    if (e.keyCode === 13) {
      this.findKeysBySearch();
    }
  }

  private findKeysBySearch() {
    (this.$refs.keysMobile as HTMLFormElement)?.findKeysBySearch(this.search);
  }
}
